import HttpClient from '../httpClient';

export type EnterpriseHiringMetricsParams = {
  orgId: string;
  startDate?: string;
  endDate?: string;
  token: string;
  region?: string;
};

class AnalyticsController extends HttpClient {
  getEnterpriseHiringMetrics = async ({
    orgId,
    startDate,
    endDate,
    token,
  }: EnterpriseHiringMetricsParams) => {
    const response = await this.client.get(
      `/analytics/enterprise/${orgId}/hiring-metrics`,
      {
        headers: {
          Authorization: token,
        },
        params: {
          ...(startDate ? { startDate } : {}),
          ...(endDate ? { endDate } : {}),
        },
      },
    );
    return response.data;
  };
}

export default new AnalyticsController(
  process.env.REACT_APP_API_BASE_URL_ANALYTICS ||
    process.env.REACT_APP_API_URL_ENTERPRISE ||
    '',
);
